/* ====================================================
   FLEN — Theme JavaScript
   ==================================================== */

(function() {
  'use strict';

  /* ── NAV DRAWER ── */
  var navOverlay = document.getElementById('flenNavOverlay');
  var navDrawer = document.getElementById('flenNavDrawer');
  var btnOpenNav = document.getElementById('flenOpenNav');
  var btnCloseNav = document.getElementById('flenCloseNav');

  function openNav() {
    if (!navDrawer || !navOverlay) return;
    navDrawer.classList.add('on');
    navOverlay.classList.add('on');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    if (!navDrawer || !navOverlay) return;
    navDrawer.classList.remove('on');
    navOverlay.classList.remove('on');
    document.body.style.overflow = '';
  }

  if (btnOpenNav) btnOpenNav.addEventListener('click', openNav);
  if (btnCloseNav) btnCloseNav.addEventListener('click', closeNav);
  if (navOverlay) navOverlay.addEventListener('click', closeNav);

  /* Nav submenu toggle */
  document.querySelectorAll('.flen-nav-toggle').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var item = btn.closest('.flen-nav-item');
      if (item) item.classList.toggle('open');
    });
  });

  /* ── CART DRAWER ── */
  var cartOverlay = document.getElementById('flenCartOverlay');
  var cartDrawer = document.getElementById('flenCartDrawer');
  var btnCloseCart = document.getElementById('flenCloseCart');

  function openCart() {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.add('on');
    cartOverlay.classList.add('on');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.remove('on');
    cartOverlay.classList.remove('on');
    document.body.style.overflow = '';
  }

  if (btnCloseCart) btnCloseCart.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* Open cart buttons */
  document.querySelectorAll('.flen-open-cart').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
  });

  /* ── CART AJAX ── */
  function formatMoney(cents) {
    return '\u20B9' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function updateCartCount(count) {
    document.querySelectorAll('.flen-cart-count').forEach(function(el) {
      if (count > 0) {
        el.textContent = count;
        el.style.display = 'flex';
      } else {
        el.style.display = 'none';
      }
    });
  }

  function fetchCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        renderCartItems(cart);
      })
      .catch(function(err) {
        console.error('FLEN cart fetch error:', err);
      });
  }

  function escHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str || ''));
    return div.innerHTML;
  }

  function renderCartItems(cart) {
    var container = document.getElementById('flenCartItems');
    var totalEl = document.getElementById('flenCartTotal');
    var footerEl = document.getElementById('flenCartFooter');
    if (!container) return;

    if (!cart.items || cart.items.length === 0) {
      container.innerHTML = '<div class="flen-cart-empty">Your cart is empty</div>';
      if (totalEl) totalEl.textContent = formatMoney(0);
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = '';

    var html = '';
    cart.items.forEach(function(item) {
      var imgSrc = '';
      if (item.image) {
        // Use Shopify's size parameter - works with both CDN formats
        if (item.image.indexOf('?') > -1) {
          imgSrc = item.image + '&width=140';
        } else {
          imgSrc = item.image + '?width=140';
        }
      }
      var variantTitle = item.variant_title || '';
      html += '<div class="flen-ci">';
      html += '  <div class="flen-ci-img">';
      if (imgSrc) {
        html += '    <img src="' + imgSrc + '" alt="' + escHtml(item.title) + '" loading="lazy">';
      }
      html += '  </div>';
      html += '  <div class="flen-ci-info">';
      html += '    <div class="flen-ci-name">' + escHtml(item.product_title) + '</div>';
      if (variantTitle) {
        html += '    <div class="flen-ci-variant">' + escHtml(variantTitle) + '</div>';
      }
      html += '    <div class="flen-ci-bottom">';
      html += '      <div class="flen-ci-qty">';
      html += '        <button onclick="flenCartChange(\'' + item.key + '\', ' + (item.quantity - 1) + ')" aria-label="Decrease">−</button>';
      html += '        <span>' + item.quantity + '</span>';
      html += '        <button onclick="flenCartChange(\'' + item.key + '\', ' + (item.quantity + 1) + ')" aria-label="Increase">+</button>';
      html += '      </div>';
      html += '      <div class="flen-ci-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '    </div>';
      html += '    <a href="#" class="flen-ci-remove" onclick="flenCartChange(\'' + item.key + '\', 0); return false;">Remove</a>';
      html += '  </div>';
      html += '</div>';
    });

    container.innerHTML = html;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  /* Global cart change fn */
  window.flenCartChange = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() { fetchCart(); })
    .catch(function(err) { console.error('FLEN cart change error:', err); });
  };

  /* Silently fetch cart count on load */
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) { updateCartCount(cart.item_count); })
    .catch(function() {});

  /* ── REVEAL ON SCROLL ── */
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('v');
        }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.r').forEach(function(el) {
      ro.observe(el);
    });
  } else {
    /* Fallback: show everything */
    document.querySelectorAll('.r').forEach(function(el) {
      el.classList.add('v');
    });
  }

  /* ── HERO PILLS ── */
  document.querySelectorAll('.hero-cat').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelectorAll('.hero-cat').forEach(function(b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
    });
  });

  /* ── ACCORDION (WHY / FAQ) ── */
  window.flenAccordion = function(btn) {
    var item = btn.closest('.flen-why-item, .flen-faq-item, .why-item, .faq-item');
    if (!item) return;
    var isOpen = item.classList.contains('open');
    /* Close siblings */
    var parent = item.parentElement;
    if (parent) {
      parent.querySelectorAll('.open').forEach(function(i) {
        i.classList.remove('open');
      });
    }
    if (!isOpen) {
      item.classList.add('open');
    }
  };

  /* ── QUICK ATC (product cards on any page) ── */
  document.querySelectorAll('.flen-atc-quick').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = 'Added!';
        setTimeout(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1500);
        fetchCart();
        openCart();
      })
      .catch(function() { btn.textContent = 'Add to Cart'; btn.disabled = false; });
    });
  });

})();
